import { Injectable } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class PasswordStrengthService {
  private _tests = [
    {
      regex: /^.{8,}$/,
      text: this.translate.instant('directives.passwordStrength.8chars'),
    },
    {
      regex: /(?=.*[a-z])(?=.*[A-Z])/,
      text: this.translate.instant('directives.passwordStrength.case'),
    },
    {
      regex: /[0-9]/,
      text: this.translate.instant('directives.passwordStrength.numeric'),
    },
    {
      regex: /[\[\]^$*.{}()?"!@#%&\/,><':;|_~`\\=+-]/,
      text: this.translate.instant('directives.passwordStrength.symbol'),
    },
  ];

  tests = this._tests.map((one) => ({
    text: one.text,
    validate: (password: string) => !!one.regex.test(password),
  }));

  constructor(private translate: TranslateService) {}

  validatePassword(password: string): ValidationErrors {
    const errors = this.tests.reduce((agg, test, key: number) => {
      if (!test.validate(password)) {
        agg = { ...agg, [key]: test.text };
      }
      return agg;
    }, {} as ValidationErrors);

    return errors;
  }

  isPasswordValid(password: string) {
    const errors = this.validatePassword(password);
    return Object.keys(errors).length === 0;
  }
}
